export default class Address {
  /**
   * Create new address and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * Get full name
   *
   * @return {string}
   */
  get fullName () {
    return [this.firstName, this.middleName, this.lastName].filter(Boolean).join(' ')
  }
}
